<div
  class="train-daily-goal-progress"
  role="progressbar"
  [attr.aria-label]="ariaLabel()"
  [ngbTooltip]="tooltip()"
  container="body"
  [style.--train-daily-goal-segments]="segmentCountStyle()"
  aria-valuemin="0"
  [attr.aria-valuemax]="valueMax()"
  [attr.aria-valuenow]="valueNow()"
>
  @for (segment of segments(); track segment) {
    <span
      class="train-daily-goal-progress__segment"
      [class.train-daily-goal-progress__segment--filled]="
        isSegmentFilled(segment)
      "
      aria-hidden="true"
    ></span>
  }
</div>
